module.exports = __webpack_public_path__ + "assets/ab07e9160be16c5e83be3a691b4bc512.png";